import { render, staticRenderFns } from "./list.vue?vue&type=template&id=a48dce0c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=a48dce0c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48dce0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a48dce0c')) {
      api.createRecord('a48dce0c', component.options)
    } else {
      api.reload('a48dce0c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=a48dce0c&scoped=true", function () {
      api.rerender('a48dce0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/opcManagement/hospitalManagement/list.vue"
export default component.exports